
import { Component, Injector, Input, OnInit } from '@angular/core';
import { TemplateInstanceService } from 'tnx-admin-service/templateinstance/services';
import {
    CheckboxControlSchema, ComponentContextService, DataFormBase,
    DropdownControlSchema, EnumFileLayout, EventData,
    FileManagerControlSchema, FileUploadControlSchema, FileUploadMode, FormSchemaBase,
    TableSchema, TextControlSchema,
    TitleSchema, AppListService
} from 'tnx-shared';

import { bookmarkTypeDatasource, dicTemplateAccept, excelPartTypeDataSource, TemplateTypes } from 'tnx-admin-service/templateinstance/models';

@Component({
    selector: 'templateinstance-form',
    templateUrl: './templateinstance-form.component.html',
    styleUrls: ['./templateinstance-form.component.scss'],
    providers: [ComponentContextService],
})
export class TemplateInstanceFormComponent extends DataFormBase implements OnInit {
    @Input() templateType: TemplateTypes = TemplateTypes.word;
    @Input() testing: boolean = false;
    @Input() appCode = '';

    bookmarkTypeDatasource = bookmarkTypeDatasource;
    bookmarks = [];

    excelPartTypeDataSource = excelPartTypeDataSource;
    excels = [];

    constructor(
        protected _injector: Injector,
        private _templateInstanceService: TemplateInstanceService,
        private _appListService: AppListService
    ) {
        super(_injector);
    }

    ngOnInit() {
        if (this.testing) {
            this.model.data.id = this._commonService.guid();
        }

        super.ngOnInit();
        this.setting.baseService = this._templateInstanceService;
        this.setting.schema = <FormSchemaBase[]>[
            new TitleSchema({
                label: this._translateService.instant('Thông tin chung'),
                mdWidth: 12
            }),
            new TextControlSchema({
                field: 'name',
                label: 'Biểu mẫu',
                required: true
            }),
            new TextControlSchema({
                field: 'code',
                label: 'Mã',
                required: true
            }),
            new TextControlSchema({
                field: 'description',
                label: 'Mô tả',
                mdWidth: 12
            }),
            new FileUploadControlSchema({
                field: 'fileId',
                label: 'Đính kèm',
                accept: dicTemplateAccept.get(this.model.data.type),
                required: true,
                mdWidth: 6,
                mode: FileUploadMode.usingFileInstanceId,
                onChanged: (eventData) => {
                    if (this.templateType == TemplateTypes.word) {
                        this.updateBookmark();
                    }
                }
            }),
            new FileUploadControlSchema({
                field: 'fakeFieldId_serviceFileUpload',
                serviceCode: 'TEMPLATE',
                entity: 'ENTITY',
                label: 'Service file upload',
                accept: dicTemplateAccept.get(this.model.data.type),
                required: true,
                mdWidth: 6,
                mode: FileUploadMode.usingServiceFile,
                hidden: !this.testing
            }),
            new FileManagerControlSchema({
                field: 'fakeFileId_fileManager',
                serviceCode: 'TEMPLATE',
                entity: 'ENTITY',
                label: 'File manager',
                required: true,
                mdWidth: 12,
                layout: EnumFileLayout.LIST,
                hidden: !this.testing
            }),
            new DropdownControlSchema({
                field: 'appCode',
                displayField: 'title',
                valueField: 'code'
            }),
            new TitleSchema({
                label: this._translateService.instant(this.templateType == TemplateTypes.word ? 'Danh sách bookmark' : 'Danh sách range'),
                mdWidth: 12
            }),
            new TableSchema({
                field: 'bookmarks',
                mdWidth: 12,
                showLabel: false,
                rowTemplate: <FormSchemaBase[]>[
                    new TextControlSchema({
                        field: 'name',
                        label: 'Tên',
                        mdWidth: 12,
                        disabled: true
                    }),
                    new DropdownControlSchema({
                        field: 'dataType',
                        label: 'Kiểu dữ liệu',
                        dataSource: this.bookmarkTypeDatasource,
                        valueField: 'value',
                        displayField: 'label',
                        mdWidth: 12,
                    }),
                    new TextControlSchema({
                        field: 'dataFormat',
                        label: 'Định dạng dữ liệu',
                        mdWidth: 12
                    })
                ],
                hidden: this.templateType != TemplateTypes.word
            }),
            new TableSchema({
                field: 'excels',
                mdWidth: 12,
                showLabel: false,
                rowTemplate: <FormSchemaBase[]>[
                    new TextControlSchema({
                        field: 'dataOption',
                        label: 'Json path',
                        mdWidth: 12
                    }),
                    new TextControlSchema({
                        field: 'name',
                        label: 'Range address',
                        mdWidth: 12
                    }),
                    new CheckboxControlSchema({
                        field: 'dataType',
                        label: 'Repeat',
                        mdWidth: 12
                    }),
                    new DropdownControlSchema({
                        field: 'type',
                        label: 'Type',
                        dataSource: this.excelPartTypeDataSource,
                        valueField: 'value',
                        displayField: 'label',
                        mdWidth: 12,
                    }),
                    new FileUploadControlSchema({
                        field: 'fakeFileId_serviceFileUpload_inTable',
                        serviceCode: 'TEMPLATE',
                        entity: 'ENTITY',
                        label: 'Service file upload',
                        accept: dicTemplateAccept.get(this.model.data.type),
                        required: true,
                        mdWidth: 12,
                        mode: FileUploadMode.usingServiceFile,
                        hidden: !this.testing
                    })
                ],
                hidden: this.templateType != TemplateTypes.cxExcel,
                onAdding: (evt) => {
                    if (this.testing && evt && evt.data) {
                        evt.data.id = this._commonService.guid();
                    }
                }
            })
        ];
    }

    async updateBookmark() {
        // Get bookmarks.
        this._templateInstanceService.getBookmark(this.model.data.id, this.model.data.fileId)
            .then(rs => {
                if (rs.success) {
                    this.model.data = this._commonService.setProperty('bookmarks', rs.data, this.model.data);
                } else {
                    this._crudService.processErrorResponse(rs);
                }
            })
            .catch(err => {
                this._notifierService.showWarning("Có vẻ như là lỗi network hoặc sai api rồi :( !");
            });
    }

    async onFormInitialized(formEvent: EventData) {
        // tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail
        this._appListService.getAll().then(rs => {
            formEvent.formControls['appCode'].dataSource = rs.data;
        });

        if (this.appCode) {
            formEvent.formControls['appCode'].disabled = true;
            formEvent.model.appCode = this.appCode;
        }
    }

    async onFormEvent(evt) {
        // các event trong form
        console.log(evt);
    }

    async modifyDetailData(data) {
        // xử lý dữ liệu lấy từ get detail về: fix tạm lỗi load dữ liệu edit tableschema
        if (this.templateType == TemplateTypes.word) {
            this.bookmarks = this._commonService.cloneObject(data.bookmarks);
        } else {
            this.excels = this._commonService.cloneObject(data.excels);
        }
    }

    async onAfterGetDetail() {
        // xử lý dữ liệu sau khi đã lấy từ api (sau cả event modifyDetailData) về và trước khi hiển thị ra view
        if (this.templateType == TemplateTypes.word && this.bookmarks && this.bookmarks.length) {
            this.model.data = this._commonService.setProperty('bookmarks', this.bookmarks, this.model.data);
        } else if (this.excels && this.excels.length) {
            this.model.data = this._commonService.setProperty('excels', this.excels, this.model.data);
        }
    }

    onBeforeSave() {
        // trước khi lưu
    }
}


